import { Phone, MessageCircle, Navigation } from "lucide-react";
import { CONTACT } from "../data/content";
import { track } from "../lib/api";

export const MobileBar = () => (
  <div
    className="fixed bottom-0 inset-x-0 z-50 md:hidden grid grid-cols-3 border-t border-[#C9A55C]/25 bg-[#070708]/95 backdrop-blur-xl"
    data-testid="mobile-action-bar"
  >
    <a
      href={`tel:${CONTACT.phonePrimaryRaw}`}
      onClick={() => track("call_click", { location: "mobile_bar" })}
      className="flex flex-col items-center gap-1 py-3 text-[#F3EEE5]"
      data-testid="mobilebar-call-btn"
    >
      <Phone size={17} className="text-[#C9A55C]" />
      <span className="text-[0.6rem] uppercase tracking-[0.2em]">Call</span>
    </a>
    <a
      href={CONTACT.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => track("whatsapp_click", { location: "mobile_bar" })}
      className="flex flex-col items-center gap-1 py-3 text-[#F3EEE5] border-x border-[#C9A55C]/15"
      data-testid="mobilebar-whatsapp-btn"
    >
      <MessageCircle size={17} className="text-[#C9A55C]" />
      <span className="text-[0.6rem] uppercase tracking-[0.2em]">WhatsApp</span>
    </a>
    <a
      href={CONTACT.directions}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => track("directions_click", { location: "mobile_bar" })}
      className="flex flex-col items-center gap-1 py-3 text-[#F3EEE5]"
      data-testid="mobilebar-directions-btn"
    >
      <Navigation size={17} className="text-[#C9A55C]" />
      <span className="text-[0.6rem] uppercase tracking-[0.2em]">Directions</span>
    </a>
  </div>
);
